import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  size: "x-small",
  style: {"color":"red"}
}
const _hoisted_2 = { class: "x-dense" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "x-dense" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_Pay = _resolveComponent("Pay")!
  const _component_CashPayment = _resolveComponent("CashPayment")!
  const _component_Remittance = _resolveComponent("Remittance")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_Sepa = _resolveComponent("Sepa")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_MailerDialog = _resolveComponent("MailerDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialog) = $event)),
      minWidth: _ctx.step === 'sepa' ? '1200px' : '800px',
      title: "Gestion des encours",
      "valid-title": _ctx.validTitle,
      "hide-valid": _ctx.step === 'chooseOperation' || _ctx.step === 'paymentLink',
      "valid-disabled": _ctx.validDisabled,
      validLoading: _ctx.validLoading,
      previousDisplay: _ctx.step !== 'personalisedAmounts',
      onValid: _ctx.nextStep,
      onPrevious: _ctx.previousStep,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.close())),
      actions: _ctx.actions,
      show: !_ctx.mailerDialog,
      prefixDataCy: "PaymentManagement-valid"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _ctx.step,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.step) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 'personalisedAmounts' }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_oss_data_table, {
                  items: _ctx.accountingTransactions,
                  headers: _ctx.headers,
                  "show-select": false,
                  key: _ctx.refreshKey
                }, {
                  "item.name": _withCtx(({ item }) => [
                    _createElementVNode("div", null, _toDisplayString(item.wording +
                                    (item.invoiceNumber ? " - " + item.invoiceNumber : "")), 1),
                    (item.associatedPaymentLink)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " A déjà un lien de paiement"))
                      : _createCommentVNode("", true)
                  ]),
                  "item.amountSigned": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.amountSigned, undefined)), 1)
                  ]),
                  "body.append": _withCtx(() => [
                    _createElementVNode("tr", _hoisted_2, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-right" }, [
                        _createElementVNode("strong", null, "Total")
                      ], -1)),
                      _createElementVNode("td", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.total, undefined)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "headers"]))
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'chooseOperation' }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  subheader: "",
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    (_ctx.containsIdenticalKey)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chequePayment()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("Remise de chèque | virement | prélèvement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("Les montants sélectionnés ont été réglés par chèque, virement ou prélèvement mais le compte bancaire n'a pas encore été débité")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item, {
                      class: "mb-2 oss-list-item",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cashPayment())),
                      "data-cy": "PaymentManagement-especes"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn_next)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("Remise d'espèces")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("Les montants sélectionnés ont été réglés en espèces")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.total < 0 && _ctx.containsIdenticalKey)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPayStep()))
                        }, {
                          append: _withCtx(() => [
                            (_ctx.payIsActivated)
                              ? (_openBlock(), _createBlock(_component_v_btn_next, { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, {
                              style: _normalizeStyle(_ctx.payIsActivated ? '' : 'color:grey')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString("Payer " + (_ctx.payIsActivated ? "" : "(bientôt diponible)")), 1)
                              ]),
                              _: 1
                            }, 8, ["style"]),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                _createTextVNode("Payer le total des montants sélectionnés ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.enableSepaTransfer)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.step = 'sepa')),
                          "data-cy": "PaymentManagement-virement"
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("Ordre de virement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("Préparer un ordre de virement (multi fournisseurs, employés) pour executer le virement en une fois")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.enableSepaDirectDebit)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 3,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 'sepa'))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode("Ordre de prélèvement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode("Préparer un ordre de prélèvement (multi clients) pour executer le prélèvement en une fois")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.enableSendMail)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 4,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendMail()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.mailTitle), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.mailDescription), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.enableSplitPayment)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 5,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToSplitPayment()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode("Découper le paiement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("Découper le paiement pour définir plusieurs règlements")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'paymentLink' }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  subheader: "",
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.forCustomer)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openMailerDialogWithURL()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                _createTextVNode("Intégrer un lien de paiement dans la relance")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                _createTextVNode("Permet au destinataire de payer directement via un lien reçu avec le mail de relance (il vous faudra des crédits de paiement)")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          class: "mb-2 oss-list-item",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openMailerDialogWithURL()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createTextVNode("Intégrer un lien de paiement dans la relance")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                              default: _withCtx(() => _cache[34] || (_cache[34] = [
                                _createTextVNode("Permet au destinataire de payer directement via un lien reçu avec le mail de relance")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_list_item, {
                      class: "mb-2 oss-list-item",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                _ctx.addBudgetInsightUrlForMail = false;
                                _ctx.getDefaultMailer();
                            })
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn_next)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                            _createTextVNode("Mail simple")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                            _createTextVNode("Sans lien de paiement")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'pay' }, {
              default: _withCtx(() => [
                (_ctx.step === 'pay')
                  ? (_openBlock(), _createBlock(_component_Pay, {
                      key: 0,
                      companyId: _ctx.companyId,
                      thirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                      thirdPartyUserId: _ctx.thirdPartyUserId,
                      thirdPartyName: _ctx.thirdPartyName,
                      accountableAccountName: _ctx.accountableAccountName,
                      accountingLines: _ctx.actionAccountingLines,
                      actions: _ctx.payActions,
                      fromPaymentManagementToGenerateEmail: _ctx.thirdPartyType === 'CLIENT',
                      withoutCredits: _ctx.forCustomer,
                      onGetBudgetInsightOptions: _ctx.mailerDialogWithBudgetInsight
                    }, null, 8, ["companyId", "thirdPartyCompanyId", "thirdPartyUserId", "thirdPartyName", "accountableAccountName", "accountingLines", "actions", "fromPaymentManagementToGenerateEmail", "withoutCredits", "onGetBudgetInsightOptions"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'cashPayment' }, {
              default: _withCtx(() => [
                _createVNode(_component_CashPayment, {
                  userId: _ctx.currentUser.id,
                  companyId: _ctx.companyId,
                  accountingLines: _ctx.actionAccountingLines,
                  actions: _ctx.cashPaymentActions,
                  onAdded: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onActionDone($event)))
                }, null, 8, ["userId", "companyId", "accountingLines", "actions"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'chequePayment' }, {
              default: _withCtx(() => [
                _createVNode(_component_Remittance, {
                  companyId: _ctx.companyId,
                  actions: _ctx.chequePaymentActions,
                  accountableAccountName: _ctx.accountableAccountName,
                  accountingLines: _ctx.actionAccountingLines,
                  onAdded: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onActionDone($event)))
                }, null, 8, ["companyId", "actions", "accountableAccountName", "accountingLines"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'splitPayment' }, {
              default: _withCtx(() => [
                _createVNode(_component_oss_data_table, {
                  items: _ctx.splittedPayments,
                  headers: _ctx.splitHeaders,
                  "show-select": false,
                  "footer-props": true
                }, {
                  "item.name": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.wording +
                                (item.invoiceNumber ? " - " + item.invoiceNumber : "")), 1)
                  ]),
                  "item.amountSigned": _withCtx(({ item }) => [
                    _createVNode(_component_oss_text_field_filled, {
                      modelValue: item.amountSigned,
                      "onUpdate:modelValue": ($event: any) => ((item.amountSigned) = $event),
                      suffix: "€",
                      dense: "",
                      "single-line": "",
                      "hide-details": true,
                      class: "pl-3"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  "item.dueDate": _withCtx(({ item }) => [
                    _createVNode(_component_oss_date_picker_filled, {
                      modelValue: item.dueDate,
                      "onUpdate:modelValue": ($event: any) => ((item.dueDate) = $event),
                      "hide-details": "",
                      textFieldReadOnly: false,
                      notRequired: true
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  "item.action": _withCtx(({ item }) => [
                    _createVNode(_component_v_btn_trash, {
                      onClick: ($event: any) => (_ctx.removeSplitPayment(item)),
                      disabled: _ctx.splittedPayments.length <= 2,
                      size: "x-small"
                    }, null, 8, ["onClick", "disabled"])
                  ]),
                  "body.append": _withCtx(() => [
                    _createElementVNode("tr", _hoisted_4, [
                      _createElementVNode("td", _hoisted_5, [
                        _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Total", -1)),
                        (_ctx.total - _ctx.splittedTotal)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(" (Ecart " +
                                        _ctx.newCommonFormatCurrency(_ctx.total - _ctx.splittedTotal, undefined) +
                                        ")"), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.splittedTotal, undefined)), 1)
                        ])
                      ]),
                      _cache[38] || (_cache[38] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                      _createElementVNode("td", _hoisted_8, [
                        _createVNode(_component_VBtn, {
                          size: "x-small",
                          color: "primary",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addSplitPayment())),
                          class: "btn",
                          elevation: "0",
                          icon: "$add"
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "headers"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'sepa' }, {
              default: _withCtx(() => [
                (_ctx.step === 'sepa')
                  ? (_openBlock(), _createBlock(_component_Sepa, {
                      key: 0,
                      companyId: _ctx.companyId,
                      accountingLines: _ctx.sepaTransactions,
                      actions: _ctx.sepaActions,
                      onOnUpdated: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onActionDone()))
                    }, null, 8, ["companyId", "accountingLines", "actions"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'warnAccLinesAlreadyUsedInPaymLinks' }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _cache[39] || (_cache[39] = _createTextVNode(" Si vous allez au bout du process, les liens de paiements ci-dessous expireront ")),
                  (_openBlock(), _createBlock(_component_oss_data_table, {
                    items: _ctx.associatedPaymentLinks,
                    headers: _ctx.headers2,
                    height: _ctx.height,
                    "show-select": false,
                    key: _ctx.refreshKey
                  }, {
                    "item.createdAt": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatedDate(item.createdAt)), 1)
                    ]),
                    "item.amountSigned": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.amountSigned, undefined)), 1)
                    ]),
                    _: 1
                  }, 8, ["items", "headers", "height"]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "minWidth", "valid-title", "hide-valid", "valid-disabled", "validLoading", "previousDisplay", "onValid", "onPrevious", "actions", "show"]),
    (_ctx.mailerDialog)
      ? (_openBlock(), _createBlock(_component_MailerDialog, {
          key: 0,
          modelValue: _ctx.mailerDialog,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mailerDialog) = $event)),
          mailType: _ctx.documentDefaultMailerInfos.mailType,
          defaultSubject: _ctx.documentDefaultMailerInfos.defaultSubject,
          defaultText: _ctx.documentDefaultMailerInfos.defaultText,
          companyId: _ctx.companyId,
          thirdPartyCompanyId: _ctx.thirdPartyCompanyId,
          listDocuments: _ctx.accountingTransactions,
          withAttachment: _ctx.documentDefaultMailerInfos.withAttachment,
          budgetInsightOptions: _ctx.budgetInsightOptions,
          onMailSent: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onActionDone($event)))
        }, null, 8, ["modelValue", "mailType", "defaultSubject", "defaultText", "companyId", "thirdPartyCompanyId", "listDocuments", "withAttachment", "budgetInsightOptions"]))
      : _createCommentVNode("", true)
  ]))
}